<template>
    <b-col lg="4">
        <div class="form-item form-item-select" :class="{ 'field-error': errors.has('gender') }">
            <input type="hidden"
                   id="user_data_gender"
                   v-model="genderCode">
            <label for="user_data_gender"
                   class="form-label">Account type</label>
            <div class="select-outer" :class="{ 'disabled': isVerified }">
                <input type="text"
                       id="user_data_gender_select"
                       name="gender"
                       v-model="selected"
                       @focus="openList = true"
                       @blur="openList = hoverList ? true : false"
                       v-validate
                       data-vv-rules="required"
                       :readonly="true"
                       :disabled="sending || isVerified">
                <ul v-show="openList && !sending && !isVerified">
                    <li v-for="(gender, index) in genders"
                        :key="index"
                        @click="setItem(index, gender), openList = false"
                        @mouseover="hoverList = true"
                        @mouseleave="hoverList = false">{{ gender }}</li>
                </ul>
                <p class="field-error--description" v-show="errors.has('gender')">{{ errors.first('gender') }}</p>
            </div>
        </div>
    </b-col>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: ['updateValue', 'sending', 'showErrors', 'changeEvent', 'isVerified'],
        data () {
            return {
                genderCode: '',
                genders: {
                    male    : 'Personal',
                    company : 'Company'
                },
                openList: false,
                hoverList: false,
                selected: ''
            }
        },
        computed: {
            defaultValue () {
                return this.$store.getters.user.gender;
            },
            isCompany () {
                return this.$store.getters.user.isCompany;
            }
        },
        watch: {
            defaultValue () {
                this.genderCode = this.defaultValue;
            },

            genderCode () {
                this.updateValue('gender', this.genderCode);
            }
        },
        methods: {
            setItem (code, value) {
                this.selected = value;
                this.genderCode = code;
                this.changeEvent(code);
            }
        },
        mounted() {
            let defaultValue = this.defaultValue;

            if (this.isCompany) {
                defaultValue = 'company';
                this.changeEvent(defaultValue);
            }

            this.selected = this.genders[defaultValue];
            this.genderCode = defaultValue;
            this.updateValue('gender', this.genderCode);
        }
    }
</script>

<style lang="scss" scoped>
    :disabled{
        cursor: not-allowed;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile-edit-data/Gender.vue